import {Validators} from '@angular/forms';

import {TradingCategoriesEnum} from '@spa/api';

import {InArrayValidator, LatinDigitsValidator} from '@spa/validators';

import {BaseControl, Helper} from '../../../app/shared/classes';
import {ColorCodesEnum, ComponentTypesEnum} from '../../../app/shared/enums/common';
import {CheckboxControl, SelectControl} from '../../../app/shared/classes/controls';

export const TradeSettingsCategorySelector = 'tradingCategory';
export const TradeSettingsClientAliasSelector = 'clientAlias';
export const TradeSettingsPlatformsSelector = 'tradingPlatforms';
export const TradeSettingsPlatformsVersionSelectorPrefix = 'tradingPlatformVersions';
export const TradeSettingsUseMarginLeverageSelector = 'useMarginLeverage';
export const TradeSettingsDailyBuyingPowerMultipleSelector = 'dailyBuyingPowerMultiple';
export const TradeSettingsOvernightBuyingPowerMultipleSelector = 'overnightBuyingPowerMultiple';
export const BuyingPowerMinimumValue = 1;

export interface TradeSettingsControlsInterface {
    tradingCategory: SelectControl;
    clientAlias: BaseControl;
    tradingPlatforms: SelectControl;
    tradingPlatformVersions: SelectControl[];
    useMarginLeverage: CheckboxControl;
    dailyBuyingPowerMultiple: BaseControl;
    overnightBuyingPowerMultiple: BaseControl;

}

export const TradeSettingsControls = (): TradeSettingsControlsInterface => {
    return {
        tradingCategory: new SelectControl({
            name: TradeSettingsCategorySelector,
            value: null,
            placeholder: 'Investment Firm',
            validators: [
                Validators.required,
                InArrayValidator([TradingCategoriesEnum.Retail, TradingCategoriesEnum.Group])
            ],
            componentType: ComponentTypesEnum.Select,
            options: [
                {
                    label: Helper.textsHelper().getIsInvestmentFirm(TradingCategoriesEnum.Retail),
                    value: TradingCategoriesEnum.Retail,
                },
                {
                    label: Helper.textsHelper().getIsInvestmentFirm(TradingCategoriesEnum.Group),
                    value: TradingCategoriesEnum.Group,
                }
            ],
            floatingLabelNever: true
        }),
        clientAlias: new BaseControl({
            name: TradeSettingsClientAliasSelector,
            value: null,
            placeholder: 'Client Alias',
            validators: [LatinDigitsValidator()],
            componentType: ComponentTypesEnum.Text,
            invalid: false,
            upperCaseValue: true,
            floatingLabelNever: true
        }),
        tradingPlatforms: new SelectControl({
            name: TradeSettingsPlatformsSelector,
            value: null,
            validators: [],
            placeholder: 'Trading Platform',
            componentType: ComponentTypesEnum.Select,
            options: [],
            multiple: true,
            floatingLabelNever: true
        }),
        tradingPlatformVersions:[],
        useMarginLeverage: new CheckboxControl({
            name: TradeSettingsUseMarginLeverageSelector,
            value: null,
            placeholder: 'Margin/Leverage',
            validators: [],
            componentType: ComponentTypesEnum.Checkbox,
            invalid: false,
            floatingLabelNever: true,
            expectBooleanValue: true,
            checked: false,
            color: ColorCodesEnum.Primary
        }),
        dailyBuyingPowerMultiple: new BaseControl({
            name: TradeSettingsDailyBuyingPowerMultipleSelector,
            value: null,
            placeholder: 'Daily BP Multiple',
            validators: [Validators.min(BuyingPowerMinimumValue)],
            componentType: ComponentTypesEnum.Text,
            invalid: false,
            floatingLabelNever: true
        }),
        overnightBuyingPowerMultiple: new BaseControl({
            name: TradeSettingsOvernightBuyingPowerMultipleSelector,
            value: null,
            placeholder: 'Overnight BP Multiple',
            validators: [Validators.min(BuyingPowerMinimumValue)],
            componentType: ComponentTypesEnum.Text,
            invalid: false,
            floatingLabelNever: true
        }),
    };
};
